import moment from 'moment'

// Mirrors server models/fleetEquipment/Vehicles.js (LOLER_* lists) and
// helpers/fleet/lolerStatus.js (interval + state names) - keep in step.

export const LOLER_EQUIPMENT_TYPES = [
  'Tail lift',
  'Wheelchair lift',
  'Ramp winch',
  'Stretcher loading system',
  'Patient hoist',
  'Other',
]

export const LOLER_EXAMINATION_TYPES = [
  'Periodic thorough examination',
  'Examination under a written scheme',
  'Before first use / after installation',
  'After exceptional circumstances',
]

export const LOLER_OUTCOMES = ['Pass', 'Pass with observations', 'Fail']

// Equipment lifting people: every 6 months; anything else: every 12
// (LOLER reg. 9(3)(a)). A written scheme of examination can set its own.
export const lolerIntervalMonths = (liftsPeople) => (liftsPeople === false ? 12 : 6)

export const defaultNextDue = (examinationDate, liftsPeople) =>
  examinationDate && moment(examinationDate).isValid()
    ? moment(examinationDate).add(lolerIntervalMonths(liftsPeople), 'months').toDate()
    : null

// `lolerStatus.state` (server virtual) → wording and palette tone
export const LOLER_STATE = {
  ok: { label: 'In date', short: 'In date', tone: 'success' },
  dueSoon: { label: 'Due within 30 days', short: 'Due soon', tone: 'warning' },
  expired: { label: 'Examination overdue', short: 'Overdue', tone: 'error' },
  failed: { label: 'Failed - do not use', short: 'Failed', tone: 'error' },
  missing: { label: 'Tail lift not examined', short: 'No record', tone: 'warning' },
}

export const OUTCOME_COLOR = {
  Pass: 'success',
  'Pass with observations': 'warning',
  Fail: 'error',
}
